import { EntityData, initialEntityData } from '@new/common/utils/entity-data';
import {
  BookletType,
  ExamQuestionGroupQGId,
  ExamQuestions
} from '@new/pools/lib/types';

export interface ExamQuestionGroupsStateModel {
  items: EntityData<ExamQuestions>;
  selectedIds: ExamQuestionGroupQGId[];
  selectedBooklet: BookletType;
  assetSize: number;
}

export const examQuestionGroupsStateDefaults: ExamQuestionGroupsStateModel = {
  items: initialEntityData(),
  selectedIds: [],
  selectedBooklet: BookletType.A,
  assetSize: 0
};
